import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  // canActivate(): boolean {
  //   const token = localStorage.getItem("token");

  //   if (!token || this.isTokenExpired(token)) {
  //     // Token is missing OR expired
  //     this.router.navigate(["/auth/signin"]);
  //     return false;
  //   }

  //   return true;
  // }

  // private isTokenExpired(token: string): boolean {
  //   try {
  //     const payload = JSON.parse(atob(token.split(".")[1]));
  //     const expiry = payload.exp;
  //     if (!expiry) return true;

  //     // exp is in seconds, convert to ms
  //     return Math.floor(Date.now() / 1000) >= expiry;
  //   } catch (e) {
  //     return true;
  //   }
  // }
  private getTokenExpiry(token: string): number | null {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.exp ? payload.exp * 1000 : null; // convert to ms
    } catch (e) {
      return null;
    }
  }

  private isTokenExpired(token: string, offsetMinutes = 0): boolean {
    const expiry = this.getTokenExpiry(token);
    if (!expiry) return true;

    const now = Date.now();
    const offset = offsetMinutes * 60 * 1000; // convert minutes to ms
    return now >= expiry - offset;
  }

  canActivate(): boolean {
    const token = localStorage.getItem("token");

    if (!token || this.isTokenExpired(token, 5)) {
      // check 5 min before expiry
      // token missing or about to expire
      // alert("Session is about to expire. Please login again.");
      this.router.navigate(["/auth/signin"]);
      return false;
    }

    this.scheduleAutoLogout(token); // schedule logout exactly at expiry
    return true;
  }

  private logoutTimer: any;

  private scheduleAutoLogout(token: string) {
    const expiry = this.getTokenExpiry(token);
    if (!expiry) return;

    const timeout = expiry - Date.now();
    clearTimeout(this.logoutTimer); // clear previous timers
    this.logoutTimer = setTimeout(() => {
      // alert("Session expired. Logging out.");
      localStorage.removeItem("token");
      this.router.navigate(["/auth/signin"]);
    }, timeout);
  }
}
